"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pInt = void 0;
var IRConst_1 = require("../../../../IR/IRNodes/IRConst.js");
var Term_1 = require("../../../Term/index.js");
var types_1 = require("../../../type_system/types.js");
var TermInt_1 = require("../UtilityTerms/TermInt.js");
function pInt(n) {
    return (0, TermInt_1.addPIntMethods)(new Term_1.Term(types_1.int, function (_dbn) { return IRConst_1.IRConst.int(BigInt(n)); }, true));
}
exports.pInt = pInt;
